// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import { SummaryUtils_CheckoutConfigOptionGroupFragmentDoc } from '../../../utils/summary.utils.generated';
import { ConfiguratorContext_ProgramDataFragmentDoc, ConfiguratorContext_CheckoutConfigInteriorSubStepFragmentDoc } from '../../../fragments/circularFragments.generated';
export type SummaryCards_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, reservedAt?: Types.Scalars['DateTime']['input'] | null | undefined, expiresAt?: Types.Scalars['Date']['input'] | null | undefined, salesPriceInCents: number, totalPriceInCents: number, mhTotalPriceInCents: number, mhSalesPriceInCents: number, aduTotalPriceInCents: number, aduSalesPriceInCents: number, isReversed: boolean, productOffering?: { __typename?: 'ProductOffering', id: string, name: string, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, totalPriceInCents: number, salesPriceInCents?: number | null | undefined } | null | undefined } | null | undefined, optionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, isEnabled: boolean, subStepNumber?: number | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean, isSpecLevel: boolean, isInteriorScheme: boolean } }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, marketingName: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } }>, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined }>, programData?: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined } | null | undefined, aduProgramData?: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, name: string, baseConfig?: { __typename?: 'ProductOfferingConfig', id: string, salesPriceInCents?: number | null | undefined } | null | undefined } | null | undefined, interiorSubSteps: Array<{ __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, stepNumber: number, location?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string } } | null | undefined }> };

export const SummaryCards_CheckoutConfigFragmentDoc = gql`
    fragment SummaryCards_CheckoutConfig on CheckoutConfig {
  id
  reservedAt
  expiresAt
  salesPriceInCents
  totalPriceInCents
  mhTotalPriceInCents
  mhSalesPriceInCents
  aduTotalPriceInCents
  aduSalesPriceInCents
  isReversed
  productOffering {
    id
    name
    baseConfig {
      id
      totalPriceInCents
      salesPriceInCents
    }
  }
  optionGroups {
    ...SummaryUtils_CheckoutConfigOptionGroup
  }
  programData {
    ...ConfiguratorContext_ProgramData
  }
  aduProgramData {
    ...ConfiguratorContext_ProgramData
  }
  aduProductOffering {
    id
    name
    baseConfig {
      id
      salesPriceInCents
    }
  }
  interiorSubSteps {
    ...ConfiguratorContext_CheckoutConfigInteriorSubStep
  }
}
    ${SummaryUtils_CheckoutConfigOptionGroupFragmentDoc}
${ConfiguratorContext_ProgramDataFragmentDoc}
${ConfiguratorContext_CheckoutConfigInteriorSubStepFragmentDoc}`;